import { Component, Input } from '@angular/core';
import { LoginProvider } from '../../providers/login/login';
import { AppState } from '../../config/state';
import { Events, LoadingController } from 'ionic-angular';
import { DatabaseProvider } from '../../providers/database/database';
import { Collection } from 'lokijs';
/**
 * Generated class for the CoAccountListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-account-list',
  templateUrl: 'co-account-list.html'
})
export class CoAccountListComponent {
  @Input() blockInfo: any;
  users: Array<any>;
  patronCollection: Collection;
  constructor(private loginProvider: LoginProvider, private state: AppState, private events : Events, private loader: LoadingController, private db : DatabaseProvider) {


    // this.events.subscribe('patronLoggedIn', (res) => {
    //   console.log('getting users for burger', res);
    //     this.getUsers();
    // });
  }

  ngOnInit() {
    this.events.subscribe('patronLoggedIn', (res) => {
      // console.log('getting users for burger', res);
        this.getUsers();
    });
    if (!this.blockInfo) {
      this.blockInfo.title = "User Accounts";
    }
    this.getUsers();
  }

  async getUsers() {
    // this.patronCollection = this.db.getCollection('patrons');
    this.loginProvider.getPatronCollection().then(list =>{
      console.log(list);
      this.users = list;
    });
    // console.log(this.users);
  }

  addNewUser() {
    this.loginProvider.newLoginUser((res) => {
    })
  }

  switchUser(user) {
    if (user.id === this.state.loggedInPatronId) {
      return;
    }
    let loading = this.loader.create({content:'Switching users...'});
    loading.present();
    this.loginProvider.login(user.barcode, user.pin).then((res) => {
      this.getUsers();
      loading.dismiss().catch(err=>{});
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // this.events.unsubscribe('patronLoggedIn');
  }

}



// WEBPACK FOOTER //
// ./src/components/co-account-list/co-account-list.ts